export interface ISolarAccountViewPhone {
  phoneContactId: number;
  isPrimary: boolean;
  phoneNumber: number;
  phoneExtension: string;
  phoneType: string;
  phoneTypeCode: string;
}

export class SolarAccountViewPhone implements ISolarAccountViewPhone {
  phoneContactId: number;
  isPrimary: boolean;
  phoneNumber: number;
  phoneExtension: string;
  phoneType: string;
  phoneTypeCode: string;
}
